'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var extend_1 = require("./extend");

var provider_1 = require("./provider");

var thorify = function thorify(web3Instance) {
  var host = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'http://localhost:8669';
  var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var provider = new provider_1.ThorProvider(host, timeout);
  web3Instance.setProvider(provider);
  extend_1.extend(web3Instance);
  return web3Instance;
};

exports.thorify = thorify;